import type { TrafficQualityData } from '@/api/types';
import template from './dashboard.html?raw';

// dashboard.html is the standalone traffic quality report kept verbatim (styles, markup and
// script), with its embedded `const DATA = {...}` swapped for this token. The page fills it in
// and renders the result in an iframe, so the report looks and behaves exactly as the file does.
export const DATA_TOKEN = '__TQ_DATA__';

/**
 * The report as a complete HTML document with `data` embedded. Inside a <script>, every "<" is
 * written as < so a "</script>" in any value cannot end the tag early; the replacement is a
 * function so "$&"-style sequences in the data are not read as replacement patterns.
 */
export function dashboardDocument(data: TrafficQualityData, html: string = template): string {
  const json = JSON.stringify(data).replace(/</g, '\\u003c');
  return html.replace(DATA_TOKEN, () => json);
}
